import './closest';
import './objectFit';
import './eventListener';
import './intersectionObserver';

document.documentElement.style.setProperty('--header-height', '0px');
